import { Canvas } from "components";
import { models, modelSettings } from "models";

const Bathroom = () => {
    return <Canvas model={models.bathroom} settings={modelSettings.bathroom} />;
};

export default Bathroom;
